import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import EmptyState from '../../../pages/empty-state';
import { audiencePosts } from '../../../services/postRequests/audience';
import { hideLoader, showLoader } from '../../loader';
import CommunityFooter from '../../community/footer';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import HeaderSearch from '../../community/headerSearch';
import { apiUrl, protocol, pageUrl } from '../../../utils/url';
import userIcon from "../../../assets/img/grey-user-icon.svg"
import dotsIcon from "../../../assets/img/dots.svg"
import { ChevronRight } from '../../../utils/svg';
import setDateFormat from '../../../utils/setDateFormat';


const ExportHistory = (props) => {
    const { loading, setloading, params, filter, setfilter, getExportHistory, exportHistory, setExportHistory, productData, campaign_id, productSlug } = props;
    const { slug, basePath } = useSelector(state => state?.slugReducer);
    const history = useHistory();
    const sendTocampaigns = () => {
        history.push(basePath + "/campaigns")
    }

    const downloadCSV = (token) => {
        var url = 'http://127.0.0.1:8000/';
        if (apiUrl == 'https://dev.backend.genpage.ai/api') {
            url = 'https://dev.backend.genpage.ai/';
        } else if (apiUrl == 'https://backend.genpage.ai/api') {
            url = 'https://backend.genpage.ai/';
        }
        window.open(url + `export-subscribers/` + token, '_blank');
    }
    return (
        < >
            <section className='export-history-sec'>

                <div class="generate-page-heading text-left">Import History </div>

                {!exportHistory?.data?.length > 0 ?
                    <div class="section-main sec-main-u p-0 position-relative">
                        <EmptyState from={"export_history"} search={filter?.search} firstText={'Import Leads From A Campaign'} secondText={"Create a campaign, and import leads to generate a custom landing page for each one."} clickedFunction={sendTocampaigns} />
                    </div>
                    :
                    <div class="section-main sec-main-u">


                        <div class="d-flex table-responsive">
                            <table class="table" border="0">
                                <thead class="d-md-table-header-group dashview-u">
                                    <tr>
                                        <th scope="col" className={`aud-leftborder thead-padd aud-text`}>
                                            #ID
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                                                <path d="M12 5.8H1M8.94444 1V3.4M4.05556 1V3.4M3.93333 13H9.06667C10.0934 13 10.6068 13 10.999 12.8038C11.3439 12.6312 11.6244 12.3559 11.8002 12.0172C12 11.6321 12 11.1281 12 10.12V5.08C12 4.07191 12 3.56786 11.8002 3.18282C11.6244 2.84413 11.3439 2.56876 10.999 2.39619C10.6068 2.2 10.0934 2.2 9.06667 2.2H3.93333C2.90657 2.2 2.39319 2.2 2.00102 2.39619C1.65605 2.56876 1.37559 2.84413 1.19982 3.18282C1 3.56786 1 4.07191 1 5.08V10.12C1 11.1281 1 11.6321 1.19982 12.0172C1.37559 12.3559 1.65605 12.6312 2.00102 12.8038C2.39319 13 2.90657 13 3.93333 13Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <span className="ms-2">
                                                Date
                                            </span>
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M12.7142 13C12.7142 12.0696 12.7142 11.6044 12.5958 11.2259C12.3292 10.3736 11.6414 9.70669 10.7625 9.44816C10.3722 9.33333 9.89243 9.33333 8.93298 9.33333H5.49549C4.53603 9.33333 4.05631 9.33333 3.66595 9.44816C2.78705 9.70669 2.09926 10.3736 1.83265 11.2259C1.71423 11.6044 1.71423 12.0696 1.71423 13M10.308 4C10.308 5.65685 8.92286 7 7.21423 7C5.5056 7 4.12048 5.65685 4.12048 4C4.12048 2.34315 5.5056 1 7.21423 1C8.92286 1 10.308 2.34315 10.308 4Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <span className="ms-2">
                                                Leads
                                            </span>
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 14C10.6787 11.8171 10.7261 16.2383 14 12.6667M2.04411 12.2101C2.05031 11.9587 2.05341 11.8331 2.08379 11.7151C2.11072 11.6104 2.15338 11.5105 2.21029 11.4188C2.27447 11.3153 2.36296 11.2264 2.53993 11.0487L11.2417 2.30865C11.5908 1.95805 12.136 1.89931 12.5511 2.16754C13.0433 2.48553 13.4638 2.9034 13.7857 3.39431L13.8082 3.42871C13.8245 3.45358 13.8327 3.46601 13.8396 3.47721C14.0951 3.88885 14.0411 4.42196 13.7081 4.77337C13.6991 4.78293 13.6886 4.79345 13.6676 4.81451L5.01874 13.5014C4.83516 13.6858 4.74337 13.7779 4.63623 13.8439C4.54125 13.9023 4.43769 13.9452 4.32937 13.9712C4.20719 14.0005 4.07739 14.0003 3.81777 13.9999L2 13.997L2.04411 12.2101Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            <span className="ms-2">
                                                Campaign
                                            </span>
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                            View Leads
                                        </th>
                                        <th scope="col" className={`thead-padd`}>
                                            Download
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>

                                {
                                    loading ?
                                        <tbody>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        :
                                        <tbody>
                                            {
                                                exportHistory?.data?.length > 0 && (
                                                    exportHistory?.data?.map((val, index) => (
                                                        <tr key={index}>
                                                            <td scope="row">
                                                                {val?.id}
                                                            </td>
                                                            <td class="d-md-table-cell ps-0 prodname">{setDateFormat(val?.created_at)}</td>
                                                            <td class="d-md-table-cell ps-0 prodname">{val?.total_rows}</td>
                                                            <td class="d-md-table-cell ps-0 prodname">
                                                                <div className="btn-fafafa border-radius-9 cursor-pointer">
                                                                    <span className="box-18f">
                                                                    </span>
                                                                    <span>
                                                                        <div className="text-decoration-none text-dark">
                                                                            {productData?.name}
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td className="view-link-td">
                                                                <a href={"#"} target="_blank" className=" cursor-pointer border-radius-9 btn-fafafa">
                                                                    <span>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                                            <rect x="10.3594" y="3.86816" width="1.348" height="10.11" rx="0.673998" transform="rotate(45 10.3594 3.86816)" fill="#1188FF" />
                                                                            <rect x="11.4492" y="3.52637" width="1.38781" height="6.93906" rx="0.693906" transform="rotate(90 11.4492 3.52637)" fill="#1188FF" />
                                                                            <rect width="1.38781" height="6.93906" rx="0.693906" transform="matrix(-1 0 0 1 11.5312 3.60938)" fill="#1188FF" />
                                                                        </svg>
                                                                    </span>
                                                                    <span>
                                                                        <div className="text-decoration-none text-dark view-landing-page">
                                                                            View Leads
                                                                        </div>
                                                                    </span>
                                                                </a>
                                                            </td>
                                                            <td className="copy-link-td">
                                                                <div className="btn-fafafa border-radius-9 cursor-pointer">
                                                                    <span className="box-18f">
                                                                    </span>
                                                                    <span>
                                                                        <div onClick={() => downloadCSV(val?.token)} className="text-decoration-none text-dark">
                                                                            Download CSV
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end dropdown-subscribers" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                                                                    <img src={dotsIcon} width="" alt="" />
                                                                </div>
                                                                <ul class="dropdown-menu" aria-labelledby="table-action-dropdown">
                                                                    <li><a class="dropdown-item" onClick={() => downloadCSV(val?.token)} >Download CSV</a></li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}

                                        </tbody>

                                }
                            </table>
                        </div>
                    </div>
                }
            </section>
            <div class="section-footer d-flex align-items-center justify-content-between w-auto">
                <CommunityFooter loading={loading} from={"leads"} filter={filter} setfilter={setfilter} total={exportHistory?.total} last_page={exportHistory?.last_page} current_page={exportHistory?.current_page} />
            </div>
        </>
    )
}

export default ExportHistory